import API from '@/data/api'

const DataAdminStats = {
  async getUnique (params) {
    let $params = params
    return new Promise(async function (resolve, reject) {
      let p = {
        slug: 'api/stats',
        apiParams: $params
      }
      let results = await API.getData(p)
      resolve(results)
    })
  },
  async refreshData () {
    return new Promise(async function (resolve, reject) {
      let p = {
        slug: 'api/stats/generate',
        apiParams: {
          timeframe: 'year',
          category: 'all',
          range: '2019-08'
        }
      }
      let results = await API.getData(p)
      resolve(results)
    })
  }
}

export default DataAdminStats



// WEBPACK FOOTER //
// ./src/data/controllers/Admin/Stats/DataAdminStats.js